export default function assemblyReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_ASSEMBLY":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
